import {$getTableColumnIndexFromTableCellNode, $isTableCellNode, TableNode} from "@lexical/table"
import {$getNearestNodeFromDOMNode} from "lexical"

export const RESIZE_HANDLE_WIDTH = 8

// Finds the td/th under the pointer, walking up from the event target
export const getCellElemFromTarget = (target: EventTarget | null): HTMLElement | null => {
    let node = target as HTMLElement | null

    while (node) {
        const name = node.nodeName
        if (name === 'TD' || name === 'TH') {
            return node
        }
        // stop at the editor root rather than escaping into the page
        if (node.getAttribute && node.getAttribute('contenteditable') === 'true') {
            return null
        }
        node = node.parentElement
    }

    return null
}

// True when the pointer sits over the cell's right edge
export const isOverRightEdge = (cellElem: HTMLElement, clientX: number) => {
    const rect = cellElem.getBoundingClientRect()

    return clientX >= rect.right - RESIZE_HANDLE_WIDTH && clientX <= rect.right + RESIZE_HANDLE_WIDTH
}

// Column widths as currently rendered. setColWidths needs a value for every column, and a table that
// has never been resized has no stored widths, so measure the widest row instead of assuming.
export const measureColumnWidths = (tableElem: HTMLElement): number[] => {
    // NodeList is not a lodash List - convert first, or _.map resolves to the wrong overload
    const rows = Array.from(tableElem.querySelectorAll('tr'))

    let widest: number[] = []
    _.forEach(rows, row => {
        const cells = Array.from(row.querySelectorAll('td,th'))
        if (cells.length <= widest.length) {
            return
        }
        widest = _.map(cells, cell => {
            return cell.getBoundingClientRect().width
        })
    })

    return widest
}

// Column index of a cell. Only meaningful when no cell before it spans columns, so callers must
// restrict resizing to simple tables.
export const getColumnIndex = (cellElem: HTMLElement) => {
    const cellNode = $getNearestNodeFromDOMNode(cellElem)
    if (!$isTableCellNode(cellNode)) {
        return null
    }

    return $getTableColumnIndexFromTableCellNode(cellNode)
}

export const applyColumnWidth = (tableNode: TableNode, index: number, width: number, measured: number[]) => {
    const current   = tableNode.getColWidths()
    const widths    = current && current.length === measured.length ? [...current] : [...measured]

    if (index < 0 || index >= widths.length) {
        return
    }

    widths[index] = width
    tableNode.setColWidths(widths)
}
